module.exports = "/images/vendor/flag-icon-css/flags/4x3/tl.svg?3c1ccf1158d75af368e003eeac4716c7";